import { getAuthGuidFromAccountContextCookie } from "src/shared/utils/cookie";
import { fetchWithToken } from "src/shared/api";

export const getAptBasedAccessToken = async (state, cimaToken) => {
  const {
    config: {
      oauthOptions: { clientId },
      flags: featuresFlags,
      urls: { customerAccountAuthentication },
    },
  } = state;

  const authGuid = getAuthGuidFromAccountContextCookie(state);
  const isAPTFlagEnabled = !!featuresFlags?.enableUserAccountContextUsingAPTCookie;

  const cimaAccessToken = {
    accessToken: cimaToken,
  };

  const fetchAptBasedAccessToken = async () => {
    const response = await fetchWithToken(
      customerAccountAuthentication,
      cimaToken,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Auth-Guid": authGuid,
        },
        body: JSON.stringify({
          client_id: clientId,
          access_token: cimaToken,
        }),
      },
    );

    if (!response.ok) {
      return cimaAccessToken;
    }

    return response.json();
  };

  if (isAPTFlagEnabled && authGuid && cimaToken) {
    try {
      const data = await fetchAptBasedAccessToken();

      return {
        accessToken: data.access_token ?? cimaToken,
      };
    } catch {
      return cimaAccessToken;
    }
  }

  return cimaAccessToken;
};

if (typeof window !== "undefined") {
  window.XHS = window.XHS || {};
  window.XHS.auth = window.XHS.auth || {};
  window.XHS.auth.getAptBasedAccessToken = getAptBasedAccessToken;
}
